import { useNotify } from '@hotjar/hotsauce';
import { useEffect } from 'react';
import { isEmbedUrlValid } from '../../utils/prototype-utils/prototype-utils';

type Props = {
  url: string;
};

export function PrototypeRenderer({ url }: Props) {
  const { showToast } = useNotify();

  const isValidUrl = isEmbedUrlValid(url);

  useEffect(() => {
    if (!isValidUrl) {
      showToast({ text: 'Invalid prototype url', kind: 'danger' });
    }
  }, [isValidUrl, showToast]);

  if (!isValidUrl) {
    return null;
  }

  return (
    <iframe
      title="VOC Prototype Renderer"
      data-testid="proto-iframe"
      style={{ width: '100%', height: '100%' }}
      src={url}
      allowFullScreen
    ></iframe>
  );
}
